import { Fragment } from 'react';
import Dropzone from 'react-dropzone-uploader';

const MyDropzone = ({ images }) => {
  // specify upload params and url for your files
  const getUploadParams = ({ meta }) => {
    return { url: process.env.NEXT_PUBLIC_API + '/_object/images' }
  }

  // called every time a file's `status` changes
  const handleChangeStatus = ({ meta, remove, file, xhr}, status) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          console.log(result);
          if(result?.status == 'ok')
            images.push(result.data.path);
        }
      }
    }
  }

  return (
    <Fragment>
      <div id="toast"></div>
      <Dropzone
        getUploadParams={getUploadParams}
        onChangeStatus={handleChangeStatus}
        accept="image/*"
        inputContent={(files, extra) => (extra.reject ? 'Только фотографии' : 'Выберите фото для загрузки')}
        inputWithFilesContent='Добавить фото'
        submitButtonContent='OK'
        styles={{
          dropzoneReject: { borderColor: 'red', backgroundColor: '#DAA' },
          inputLabelWithFiles: { marginBottom: 10 },
          inputLabel: (files, extra) => (extra.reject ? { color: 'black' } : {}),
        }}
      />
    </Fragment>
  )
};

export default MyDropzone;
